import axios from "axios";
import Cookies from "js-cookie";
import store  from "../redux/store";
import { logout } from "../redux/hejalSlice";

/**
 * Add Base URL
 */
const API_BASE_URL = process.env.REACT_APP_URL;

/**
 * Function to make API requests using Axios
 * @param {Object} params - The request parameters
 * @param {string} params.method - The HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {string} params.endpoint - The API endpoint
 * @param {Object} [params.headers] - Additional headers for the request
 * @param {Object} [params.data] - Data to be sent with the request (for POST and PUT requests)
 * @returns {Promise<any>} - A Promise that resolves with the API response data
 */
const ApiService = async ({ method, endpoint, data, headers = {} }) => {
  // const token = localStorage.getItem("accessToken");
  const token = Cookies.get("accessToken");
  const axiosConfig = {
    // withCredentials: true,
    method,
    url: `${API_BASE_URL}/${endpoint}`,
    data,
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
          ...headers,
        }
      : headers,
  };

  const api = axios.create();

  api.interceptors.request.use((config) => {
    return config;
  });

  api.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      console.error("API Response Error:", error);
      throw error;
    }
  );

  try {
    const response = await api(axiosConfig);
    return response;
  } catch (error) {
    if (error?.response?.data?.tokenExpired) {
      try {
        const tokenResponse = await axios.get(
          `${API_BASE_URL}/api/auth/refreshtoken`,
          {
            withCredentials: true,
            headers: { Authorization: `Bearer ${Cookies.get("refreshToken")}` },
          }
        );
        if (tokenResponse?.data?.success) {
          Cookies.set("accessToken", tokenResponse.data.token);
          axiosConfig.headers.Authorization = `Bearer ${tokenResponse.data.token}`;
          const response = await api(axiosConfig);
          return response;
        }
      } catch (error) {
        if (error.status === 403) {
          store.dispatch(logout());
          window.location.href = "/";
        }
      }
    }
    if (!Cookies.get("accessToken") && !Cookies.get("refreshToken")) {
      store.dispatch(logout());
    }
    throw error;
  }
};

export default ApiService;
